import React, { useState } from 'react';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import Section from 'components/common/Section';
import Phone from '../Phone';
import Footer from '../Footer';
import Flex from 'components/common/Flex';
import Name from '../Name';
import Email from 'owl/Email';
import { Link } from 'react-router-dom';

const OptIn = () => {
  const [submitted, setSubmitted] = useState(false);
  const [textOK, setTextOK] = useState(false);
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');

  return (
    <>
      <Section className="py-3" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Row className="flex-center p-0">
          <Col sm={10} lg={7} className="col-xxl-5">
            <Card>
              <Card.Body className="overflow-hidden p-lg-6">
                <Row className="align-items-center justify-content-between">
                  <Col lg={12} className="ps-lg-4 my-5 text-lg-start">
                    <h3 className="text-primary text-center">
                      Automated Project Coordinator
                    </h3>
                    <h4 className="text-center">Text Message Notifications</h4>
                    {submitted && (
                      <>
                        <p>
                          Thank you up for signing up for text notifications.
                        </p>
                      </>
                    )}
                    {!submitted && (
                      <>
                        <p className="text-left">
                          <Name /> operates a text message notification program
                          called the Automated Project Coordinator (or APC) that
                          sends opted in subscribers messages about upcoming
                          appointments and order details.
                        </p>
                        <p style={{ fontStyle: 'italic' }}>
                          By submitting your mobile phone number and checking
                          the box, you are consenting to receiving text messages
                          from <Name />. You are not required to provide your
                          mobile phone number to use our services.
                        </p>
                        <p className="text-left">
                          If you would like to receive text notifications from{' '}
                          <Name />, please enter your phone number below:
                        </p>
                        <p>
                          <Form.Label>Name:</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control"
                            id="customer-name"
                            value={name}
                            onChange={({ target }) => {
                              setName(target.value);
                            }}
                          />
                        </p>
                        <p>
                          <Form.Label>Phone Number:</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control"
                            id="phone"
                            value={phone}
                            onChange={({ target }) => {
                              setPhone(target.value);
                            }}
                          />
                        </p>
                        {/* <p>
                          <Form.Label>Your Project Number:</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control"
                            id="project-number"
                            value={projectNumber}
                            onChange={({ target }) => {
                              setProjectNumber(target.value);
                            }}
                          />
                        </p> */}
                        <Form.Check
                          type="checkbox"
                          id="Yes"
                          name="Yes"
                          value="Yes"
                          label={
                            <>
                              You agree to receive recurring informational
                              messages. You also agree to our{' '}
                              <Link to="/terms">Terms of Service</Link> and{' '}
                              <Link to="/privacy-policy">Privacy Policy</Link>.
                            </>
                          }
                          checked={textOK}
                          onChange={() => setTextOK(!textOK)}
                        />
                        {/* <Form.Check
                          type="radio"
                          id="No"
                          name="No"
                          value="No"
                          label="No, do not send text notifications"
                          checked={textOK === false}
                          onChange={() => setTextOK(false)}
                        /> */}
                        <Row className="py-3 align-items-center justify-content-between">
                          <Col>
                            <Flex justifyContent="center">
                              <Button
                                disabled={!phone || !textOK}
                                color="primary"
                                className="mx-2 my-1 btn-width"
                                type="submit"
                                onClick={setSubmitted}
                              >
                                Submit
                              </Button>
                            </Flex>
                          </Col>
                        </Row>
                      </>
                    )}
                    <p>
                      <strong>
                        You can stop receiving notifications at any time by
                        replying STOP to any message.
                      </strong>
                    </p>
                    <p>
                      Message frequency varies. Message and data rates apply.
                    </p>
                    <p>For more information, please review:</p>
                    <ul>
                      <li>
                        <Link to="/terms">Terms of Service</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                    </ul>
                    <p>
                      If you have any questions, email <Email /> or call{' '}
                      <span style={{ whiteSpace: 'nowrap' }}>
                        <Phone />
                      </span>
                      .
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Section>
      <Footer />
    </>
  );
};

export default OptIn;
